import { render, staticRenderFns } from "./PermissionsPerfilModal.vue?vue&type=template&id=d995cdee&"
import script from "./PermissionsPerfilModal.vue?vue&type=script&lang=js&"
export * from "./PermissionsPerfilModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports